import React from 'react';
import "../../style/who-are-we.scss";
import SectionContact from "../../components/SectionContact";
import SectionWawTop from "./SectionWawTop";
import SectionWawDescription from "./SectionWawDescription";
import SectionWawTeam from "./SectionWawTeam";

const WhoAreWePage = (props) => {
    return (
        <>
            <SectionWawTop/>

            <SectionWawDescription/>

            <SectionWawTeam/>

            <SectionContact className="white-wave"/>
        </>
    )
};

export default WhoAreWePage;